<script setup>
import { CircleCheck } from 'lucide-vue-next'

defineProps({
  text: {
    type: String,
    required: true
  },
  color: {
    type: String,
    default: 'green'
  }
})

const colorClasses = {
  green: 'text-emerald-600',
  blue: 'text-blue-600',
  purple: 'text-purple-600'
}
</script>

<template>
  <div class="flex items-center space-x-2">
    <CircleCheck :class="['w-5 h-5', colorClasses[color] || colorClasses.green]" />
    <span>{{ text }}</span>
  </div>
</template>
